import commonConstant from '../../common/_commonConstant';
import { checkTimeToRefreshToken, getCookieToken } from '../../common/_commonFunction';
import { history } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchSearchVehiclePlateOrCompanyNameInBuilding = (buildingID, vehicleLicensePlatesLike, tenantNamesLike) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/tenant-member-report?buildingID=${buildingID}&offset=0&limit=0&${vehicleLicensePlatesLike ? `&vehicleLicensePlatesLike=${vehicleLicensePlatesLike}` : ''}${tenantNamesLike ? `&tenantNamesLike=${tenantNamesLike}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_SUCCESS,
          'data': (
            data?.metadata?.searchKeywords ?
              vehicleLicensePlatesLike ?
                data?.metadata?.searchKeywords.vehicleLicensePlates.split(',')
                : tenantNamesLike ?
                  data?.metadata?.searchKeywords.tenantNames.split(',')
                  : []
              : []
          ),
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchAccountingSearchVehiclePlateOrReferenceCode = (buildingRefNo, vehicleLicensePlateLike, parkingRefNoLike, from, to, vehicleTypes) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/accounting-report?buildingRefNo=${buildingRefNo ? buildingRefNo : ''}&offset=0&limit=0&${vehicleLicensePlateLike ? `&vehicleLicensePlateLike=${vehicleLicensePlateLike}` : ''}${parkingRefNoLike ? `&parkingRefNoLike=${parkingRefNoLike}` : ''}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}${vehicleTypes ? `&vehicleTypes=${vehicleTypes}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_SUCCESS,
          'data': data.data,
          'metadata': data.metadata,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchSearchVehiclePlateOrParkingRefInOperationReport = (buildingRefNo, vehicleLicensePlateLike, parkingRefNoLike, from, to, vehicleTypes) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/parking-report?buildingRefNo=${buildingRefNo ? buildingRefNo : ''}&offset=0&limit=0&${vehicleLicensePlateLike ? `&vehicleLicensePlateLike=${vehicleLicensePlateLike}` : ''}${parkingRefNoLike ? `&parkingRefNoLike=${parkingRefNoLike}` : ''}${from ? `&from=${from}` : ''}${to ? `&to=${to}` : ''}${vehicleTypes ? `&vehicleTypes=${vehicleTypes}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_SUCCESS,
          'metadata': data.metadata,
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_FAILURE,
        'metadata': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_FAILURE,
        'metadata': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const setSearchVehicleType = vehicleType => (
  async dispatch => {
    try {
      return dispatch({
        'type': commonConstant.SEARCH_VEHICLE_TYPE_SUCCESS,
        'data': vehicleType,
        'status': 200,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SEARCH_VEHICLE_TYPE_FAILURE,
        'data': vehicleType,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchSearchVehiclePlateInBuilding = (buildingID, vehicleLicensePlatesLike , limit , offset) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/tenant-member-report?buildingID=${buildingID}&offset=${offset ? offset : 0}&limit=${limit ? limit : 0}&${vehicleLicensePlatesLike ? `&vehicleLicensePlatesLike=${vehicleLicensePlatesLike}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.SEARCH_VEHICLE_PLATE_IN_BUILDING_SUCCESS,
          'data': (
            data?.metadata?.searchKeywords ?
              vehicleLicensePlatesLike ?
                data?.metadata?.searchKeywords.vehicleLicensePlates.split(',')
                : []
              : []
          ),
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.SEARCH_VEHICLE_PLATE_IN_BUILDING_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SEARCH_VEHICLE_PLATE_IN_BUILDING_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchSearchCompanyNameInBuilding = (buildingID, tenantNamesLike , limit , offset) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/tenant-member-report?buildingID=${buildingID}&offset=${offset ? offset : 0}&limit=${limit ? limit : 0}&${tenantNamesLike ? `&tenantNamesLike=${tenantNamesLike}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.SEARCH_COMPANY_NAME_IN_BUILDING_SUCCESS,
          'data': (
            data?.metadata?.searchKeywords ?
              tenantNamesLike ?
                data?.metadata?.searchKeywords.tenantNames.split(',')
                : []
              : []
          ),
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.SEARCH_COMPANY_NAME_IN_BUILDING_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SEARCH_COMPANY_NAME_IN_BUILDING_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchSearchMemberNameInBuilding = (buildingID, customerNamesLike , limit , offset) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/reports/tenant-member-report?buildingID=${buildingID}&offset=${offset ? offset : 0}&limit=${limit ? limit : 0}&${customerNamesLike ? `&customerNamesLike=${customerNamesLike}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.SEARCH_MEMBER_NAME_IN_BUILDING_SUCCESS,
          'data': (
            data?.metadata?.searchKeywords ?
              customerNamesLike ?
                data?.metadata?.searchKeywords.customerNames.split(',')
                : []
              : []
          ),
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.SEARCH_MEMBER_NAME_IN_BUILDING_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.SEARCH_MEMBER_NAME_IN_BUILDING_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);
